import { taskIdFormat } from "@redotech/redo-ids-cockroach";
import { UndeclaredItemActionSchema } from "@redotech/redo-model/task/task";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const completeTask = unaryRpc({
  name: "completeTask" as const,
  input: z.object({
    taskId: taskIdFormat.schema,
    /** Required when the task subtype is `undeclared_item`. */
    action: UndeclaredItemActionSchema.optional(),
    note: z.string().max(2000).optional(),
  }),
  output: z.object({}),
});
